module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(0), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.cv')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.cv')))])])])])]), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-5",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.email')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "email",
      "disabled": _vm.cv_crm_setting.email,
      "placeholder": _vm.$t('integrations.placeholder.cvCrmEmail')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    key: "email",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])], 1), _c('div', {
    staticClass: "form-group col-md-5",
    class: {
      'has-error': _vm.errors.has('cv_crm_api_token')
    }
  }, [_c('label', {
    attrs: {
      "for": "cv_crm_api_token"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.apiKey')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cv_crm_api_token),
      expression: "cv_crm_api_token"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cv_crm_api_token",
      "type": "text",
      "disabled": _vm.current_user.cv_crm_api_token,
      "placeholder": _vm.$t('integrations.placeholder.apiKey')
    },
    domProps: {
      "value": (_vm.cv_crm_api_token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cv_crm_api_token = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cv_crm_api_token')),
      expression: "errors.has('cv_crm_api_token')"
    }],
    key: "cv_crm_api_token",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('cv_crm_api_token')))])])], 1)]), _c('br'), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-5",
    class: {
      'has-error': _vm.errors.has('domain')
    }
  }, [_c('label', {
    attrs: {
      "for": "domain"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.cvCrm.clientDomain')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.domain),
      expression: "domain"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "domain",
      "type": "text",
      "disabled": _vm.cv_crm_setting.domain,
      "placeholder": _vm.$t('integrations.placeholder.cvCrmDomain')
    },
    domProps: {
      "value": (_vm.domain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.domain = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('domain')),
      expression: "errors.has('domain')"
    }],
    key: "domain",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('domain')))])])], 1), _c('div', {
    staticClass: "form-group col-md-5"
  }, [_c('label', {
    attrs: {
      "for": "webhook-url"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.cvCrm.webhooksUrl')))]), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "width": "23em"
    },
    attrs: {
      "id": "webhook-url",
      "name": "webhook-url",
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": _vm.webhook_url
    }
  }), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.copy')))]), _c('small', [_vm._v(_vm._s(_vm.$t('integrations.label.cvCrm.pasteUrl')))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "checkbox-inline contact-list-item-checkbox-item",
    on: {
      "click": function($event) {
        return _vm.toggleMarkAddContatsFromCV()
      }
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_vm._v(" ")]), _c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.add_contacts_from_cv_crm
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.cvCrm.receiveContactsTitle')))]), _c('div', {
    staticClass: "clearfix"
  }, [_vm._v(" ")])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('trigger-stages', {
    attrs: {
      "integration": "cv_crm",
      "settings": _vm.cv_crm_setting.triggers
    },
    on: {
      "selected-stages": _vm.setStagesCvCrm
    }
  })], 1)]), _c('stages-matching', {
    attrs: {
      "stages_matching": _vm.cv_crm_setting.stages_matching,
      "integration_name": "cv crm",
      "integration_stages": _vm.integration_stages,
      "pipelines": _vm.pipelines,
      "pipeline_id": _vm.selected_pipeline,
      "show_ignore_stages": true
    },
    on: {
      "matching-updated": _vm.matchingStagesUpdated,
      "users-update": _vm.updateUsers
    }
  }), _c('hr'), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), (_vm.current_user.cv_crm_api_token) ? _c('button', {
    staticClass: "pull-right btn btn-danger",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": _vm.removeCvCrmApiToken
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))]) : _vm._e(), _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('div', {
    staticClass: "cv-box"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/cv_crm.webp"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68090c0d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations/cv_crm.vue
// module id = 1161
// module chunks = 1